export enum UserTypes {
  ATENDENTE = 'ATENDENTE',
  ADMIN = 'ADMIN',
  OPERADOR = 'OPERADOR',
  PARCEIRO = 'PARCEIRO',
  SUPERVISOR = 'SUPERVISOR DE BACKOFFICE',
  MESA_CREDITO = 'MESA DE CRÉDITO',
  RETAGUARDA = 'RETAGUARDA',
  CAIXA = 'CAIXA',
  ASSESSORIA = 'ASSESSORIA',
  LIDER_VENDAS = 'LIDER DE VENDAS'
}

export const EnableTypesToAccessApp = [
  'ADM',
  'RET',
  'SUP',
  'MDC',
  'ASSESSORIA',
  'LID',
];
